import { render, staticRenderFns } from "./TransactionRecord.vue?vue&type=template&id=c2e4c21c&scoped=true"
import script from "./TransactionRecord.vue?vue&type=script&lang=js"
export * from "./TransactionRecord.vue?vue&type=script&lang=js"
import style0 from "./TransactionRecord.vue?vue&type=style&index=0&id=c2e4c21c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e4c21c",
  null
  
)

export default component.exports